export interface StoreGroup {
  id: number;
  name: string;
  owner?: number | null;
  billing_email?: string | null;
  notes?: string;
  knowledge_base_id?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface StoreGroupFormData {
  name: string;
  owner: number | null;
  billing_email: string;
  notes: string;
}

export const EMPTY_STORE_GROUP_FORM: StoreGroupFormData = {
  name: '',
  owner: null,
  billing_email: '',
  notes: '',
};

export const storeGroupFormFrom = (group: StoreGroup): StoreGroupFormData => ({
  name: group.name || '',
  owner: group.owner ?? null,
  billing_email: group.billing_email || '',
  notes: group.notes || '',
});

export const updateStoreGroupForm = (
  form: StoreGroupFormData,
  name: string,
  value: string,
): StoreGroupFormData => ({
  ...form,
  [name]: name === 'owner' ? (value ? parseInt(value, 10) : null) : value,
});

export const validateStoreGroupForm = (
  form: StoreGroupFormData,
): string | null => (form.name.trim() ? null : 'Store group name is required.');

export const storeGroupPayload = (form: StoreGroupFormData) => ({
  name: form.name.trim(),
  owner: form.owner || null,
  billing_email: form.billing_email.trim() || null,
  notes: form.notes,
});

export const storeGroupResponseError = (
  data: { detail?: string; message?: string },
  fallback: string,
) => data.detail || data.message || fallback;
